import React, { useState } from 'react';
import { PaginationButton } from '../Button/PaginationButton.js';
import { Box } from '../Box/Box.js';
import { Flex, LeftPaginationButtonWrapper, PaginationButtonWrapper } from './Pagination.styles.js';

function createPagination(totalItems, itemsPerPage, numOfPaginationsToShow) {
  var amountOfPages = Math.ceil((totalItems || 0) / (itemsPerPage !== null && itemsPerPage !== void 0 ? itemsPerPage : 6));

  if (amountOfPages === 0 || itemsPerPage === 0) {
    return [];
  }

  var pagination = [];
  var block = [];
  var counter = 0;
  new Array(amountOfPages).fill(0).map(function (_, index) {
    if (counter < (numOfPaginationsToShow !== null && numOfPaginationsToShow !== void 0 ? numOfPaginationsToShow : 4) - 1) {
      counter++;
      block.push(index);

      if (index === amountOfPages - 1) {
        pagination.push(block);
      }
    } else {
      counter = 0;
      block.push(index);
      pagination.push(block);
      block = [];
    }

    return null;
  });
  return pagination;
}

function Pagination(_a) {
  var _b;

  var totalItems = _a.totalItems,
      currentPage = _a.currentPage,
      fetchItems = _a.fetchItems,
      itemsPerPage = _a.itemsPerPage,
      setPage = _a.setPage,
      _c = _a.numOfPaginationsToShow,
      numOfPaginationsToShow = _c === void 0 ? 4 : _c,
      rightIcon = _a.rightIcon,
      leftIcon = _a.leftIcon;

  var _d = useState(Math.floor((currentPage - 1) / numOfPaginationsToShow)),
      currentIndex = _d[0],
      setIndex = _d[1];

  var pagination = createPagination(totalItems, itemsPerPage, numOfPaginationsToShow);
  return React.createElement(Box, null, pagination && pagination.length > 0 && React.createElement(Flex, null, React.createElement(LeftPaginationButtonWrapper, {
    show: currentIndex > 0
  }, currentIndex > 0 && React.createElement(PaginationButton, {
    color: 'white',
    onClick: function onClick() {
      setPage && setPage(currentPage - 1);
      setIndex(currentIndex - 1);
    },
    width: 36,
    height: 36
  }, leftIcon || '...')), (_b = pagination === null || pagination === void 0 ? void 0 : pagination[currentIndex]) === null || _b === void 0 ? void 0 : _b.map(function (page) {
    return React.createElement(PaginationButtonWrapper, {
      key: page
    }, React.createElement(PaginationButton, {
      color: currentPage === page + 1 ? 'primary' : 'white',
      width: 36,
      height: 36,
      onClick: function onClick() {
        return fetchItems(page + 1);
      }
    }, page + 1));
  }), pagination.length > 1 && currentIndex < pagination.length - 1 && React.createElement(PaginationButtonWrapper, null, React.createElement(PaginationButton, {
    color: 'white',
    onClick: function onClick() {
      return setIndex(currentIndex + 1);
    },
    width: 36,
    height: 36
  }, rightIcon || '...'))));
}

export { Pagination };